export default __webpack_public_path__ + "static/media/block.c91325da.svg";